export const titleCase = str => {
  let result = str
    ?.toLowerCase()
    ?.replace(/_/g, ' ')
    ?.replace(/\b\w/g, function (firstLetter) {
      return firstLetter.toUpperCase();
    });
  return result && result.length > 0 ? result : '-';
};
